export const DealerCampaignsSlug = {
    list: 'aktionen1',
} as const;

export function getDealerCampaignsUrl(dealerslug: string): string {
    return `/${dealerslug}/${DealerCampaignsSlug.list}`;
}

export function getDealerCampaignsDetailUrl(dealerslug: string, campaignSlug: string): string {
    return `/${dealerslug}/${DealerCampaignsSlug.list}/${campaignSlug}`;
}
